var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.4 59.9994C113.2 52.2494 109.95 40.0994 100.2 36.7994C102.2 26.6994 93.2999 17.8494 83.2499 19.8494C79.9499 10.0994 67.7999 6.84936 60.0499 13.6494C52.2999 6.84936 40.1499 10.0994 36.8499 19.8494C26.7499 17.8494 17.8999 26.7494 19.8999 36.7994C10.1499 40.1494 6.89989 52.2994 13.6999 60.0494C6.89989 67.7994 10.1499 79.9493 19.8999 83.2494C17.8999 93.3493 26.7999 102.199 36.8499 100.199C40.1499 109.949 52.2999 113.199 60.0499 106.399C67.7999 113.199 79.9499 109.949 83.2499 100.199C93.3499 102.199 102.2 93.2993 100.2 83.2494C109.95 79.8994 113.2 67.7494 106.4 59.9994Z",
    fill: "#0CAF60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9008 76.451C52.9508 76.451 52.0008 76.101 51.2508 75.351L35.4508 59.551C34.0008 58.101 34.0008 55.701 35.4508 54.251C36.9008 52.801 39.3008 52.801 40.7508 54.251L53.9008 67.401L80.6508 40.651C82.1008 39.201 84.5008 39.201 85.9508 40.651C87.4008 42.101 87.4008 44.501 85.9508 45.951L56.5508 75.351C55.8008 76.101 54.8508 76.451 53.9008 76.451Z",
    fill: "#EDEBEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.616f302a230a9dd06c0fb08e43b9f74c.svg";
export { ForwardRef as ReactComponent };